import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { categoriesIconSource } from '../../../../images/assets';
import ItemIconsList from './ItemIconsList';
import Loader from '../../../common/ui/Loader';
import { employerJobCreationStepsSingle } from '../../../../constants/jobs';
import NoRateFound from '../common/NoRateFound';

export default class SkillQuantityStep extends Component {
  static propTypes = {
    jobCategories: PropTypes.array.isRequired,
    selectedCategoryId: PropTypes.number,
    jobSkillId: PropTypes.number,
    quantityOfWorkers: PropTypes.oneOfType([
      PropTypes.string, // in case when field is empty it will be equal to empty string
      PropTypes.number
    ]),
    costPayRateList: PropTypes.array.isRequired,
    costPayRateIsLoading: PropTypes.bool.isRequired,
    chooseCategory: PropTypes.func.isRequired,
    handleChangeSkill: PropTypes.func.isRequired,
    handleChangeWorkersQuantity: PropTypes.func.isRequired,
    isPrivateParty: PropTypes.bool.isRequired,
    isSecondStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired
  };

  render () {
    const { jobCategories, use_custom_rate, selectedCategoryId, jobSkillId, chooseCategory, handleChangeSkill, quantityOfWorkers,
      handleChangeWorkersQuantity, isPrivateParty, isSecondStepFilled, goToStep, costPayRateIsLoading } = this.props;
    let skillsList = [];
    if (selectedCategoryId) {
      skillsList = jobCategories.find(category => category.id === selectedCategoryId).subcategory;
    }
    return (
      <React.Fragment>
        { !isPrivateParty &&
          <section className='job-posting-section skill-section'>
            <header><h4>I Need Help With ...</h4></header>
            <ItemIconsList
              listData={jobCategories}
              selectedItemId={selectedCategoryId}
              chooseItemHandler={chooseCategory}
              iconSource={categoriesIconSource}
              labelFieldName='category_label'
            />
          </section>
        }
        { !!selectedCategoryId && (
          <React.Fragment>
            <section className='job-posting-section skill-section'>
              <header><h4>I Need a ...</h4></header>
              <ItemIconsList
                listData={skillsList}
                selectedItemId={jobSkillId}
                chooseItemHandler={handleChangeSkill}
                iconSourceFieldName='icon_url'
                labelFieldName='skill_label'
              />
            </section>
          </React.Fragment>
        )}
        { !!jobSkillId && (
          <React.Fragment>
            { this.props.costPayRateList.length > 0 ? (
              <section className='job-posting-section'>
                <header><h4>How many workers needed?</h4></header>
                <div className='cost-estimation-wrapper'>
                  <div className='input-wrapper'>
                    <h5><label className='sub-header' htmlFor='workers-number-input'>Number of Workers:</label></h5>
                    <input
                      id='workers-number-input'
                      className='create-job-input'
                      type='number'
                      min='1'
                      value={quantityOfWorkers}
                      onChange={handleChangeWorkersQuantity}
                    />
                  </div>
                  { quantityOfWorkers > 0 && (
                    <div className='input-wrapper'>
                      <h5><p className='sub-header'>Billing Estimate:</p></h5>
                      <p className='create-job-input disabled'>
                        {this.props.estCost}
                      </p>
                    </div>
                  )}
                </div>
              </section>
            ) : (
              <React.Fragment>
                { costPayRateIsLoading ? (
                  <div>
                    <div className='loader-wrapper'><Loader /></div>
                  </div>
                ) : (
                  <NoRateFound use_custom_rate={use_custom_rate} />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <div className='nav-buttons-wrapper'>
          <button
            className='gravy-button back-step-button'
            onClick={() => goToStep(employerJobCreationStepsSingle.first.id)}
          >Back</button>
          { isSecondStepFilled() && (
            <button
              className='gravy-button info-btn'
              onClick={() => goToStep(employerJobCreationStepsSingle.third.id)}
            >Next</button>
          )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJobEmployerSingle/SkillQuantityStep.js